@if (isLoading$ | async) {
  <div class="loader" (click)="onClick()">
    <div class="inner-loader">
      <div class="lds-ripple">
        <div></div>
        <div></div>
      </div>
      <!--<div class="round"></div>-->
      @if ((message$ | async); as message) {
        <div class="title">{{ message }}</div>
      } @else {
        <div class="title">Loading...</div>
      }
    </div>
  </div>
}
